import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import { sentryMiddleware } from '../services/sentry';

const middlewares = [sentryMiddleware];

// Add logger middleware only in development
if (import.meta.env.DEV) {
  const logger = createLogger({ collapsed: true });
  middlewares.push(logger);
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore non-serializable function in notification actions and state
        ignoredActionPaths: ['payload.onClose', 'payload.onConfirm'],
        // Ignore non-serializable paths in the state
        ignoredPaths: ['notifications'],
      },
    }).concat(middlewares),
  devTools: import.meta.env.DEV,
});

export default store;
